// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  warId: __t.u64().primaryKey().name("war_id"),
  worldId: __t.u64().name("world_id"),
  lastExchangeEpoch: __t.u64().name("last_exchange_epoch"),
  exchanges: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
